import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { Swiper, SwiperSlide } from 'swiper/react';

import useContent from '@/localization/data_export';
import { programBoardList } from '@/network/apis/apiUri';

export default function BannerLine() {
  const { mode } = useSelector((state) => state);

  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const boardCustomType = useContent('boardCustomType');

  const boardId = boardCustomType ? boardCustomType.csv.find((item) => item.type === '8').id : 6;

  const observerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const { isSuccess, data } = useQuery(
    ['main', 'banner', boardId],
    async () => {
      const response = await programBoardList({
        lan_code: mode,
        board_id: boardId,
        title: '',
        content_category: '',
        event_category: null,
        is_open_allow: true,
        is_blind_allow: false,
        hit: true,
        page_info: { row_count: -1, number: 0 },
      });

      const filterType = mode === 'en' ? '2' : '1';

      return response.data.item
        .filter((item) => item.content !== filterType)
        .map((item) => ({
          id: item.board_item_id,
          image: item.image.url,
          link: item.url_link[0],
        }));
    },
    {
      staleTime: 1000 * 60 * 3,
      retry: false,
      enabled: !!mode && !!boardId,
    }
  );

  useEffect(() => {
    let observe = null;

    if (!isVisible && observerRef.current) {
      observe = new IntersectionObserver(([entry], observer) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });

      observe.observe(observerRef.current);
    }
    return () => {
      if (observe) observe.disconnect();
    };
  }, []);

  const isComplete = isSuccess && isVisible && data.length > 0;

  return (
    <div ref={observerRef} className="slide-wrapper" data-has-item={isComplete}>
      {isComplete && (
        <Swiper
          slidesPerView={1}
          navigation
          pagination={{
            type: 'fraction',
          }}
        >
          {data.map((item) => (
            <SwiperSlide key={`banner-line_${item.id}`}>
              <a href={item.link} target="_blank" rel="noreferrer" title={anchorTitle}>
                <div className="item-wrap">
                  <img
                    src={item.image}
                    alt=""
                    width={1280}
                    height={120}
                    onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                  />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}
